module.exports = __webpack_public_path__ + "img/bg.36b8dd8f.png";